import React, { useCallback, useEffect, useRef } from 'react'
import {
  PLL_LINKS,
  NAV_LINKS,
  TEAM_MENU,
  MORE_MENU,
  PLL_SITE_LOGO,
} from '../../../Config/League/league.config'
import {
  MobileNavPanel,
  MobileNavScrollArea,
  MobilePanelHeader,
  MobileNavItem,
  MobileSectionLabel,
  MobileSubItem,
  MobileCtaContainer,
  NavActionCon,
} from './styles'
import { createShopUTM } from '../../../Routing'
import { Lk } from '../../../Utils/routing'
import { Img } from '../../Images/Img'
import { NavToggle } from '../NavToggle/NavToggle'
import type { NavPanelProps } from '../navbar.types'

export const NavItems: React.FC<NavPanelProps> = ({ open, setOpen }) => {
  const panelRef = useRef<HTMLElement>(null)

  const handleClose = useCallback((): void => {
    setOpen(false)
  }, [setOpen])

  useEffect(() => {
    if (!open) return
    const firstFocusable = panelRef.current?.querySelector<HTMLElement>('a, button')
    firstFocusable?.focus()
  }, [open])

  return (
    <MobileNavPanel
      ref={panelRef}
      id="mobile-nav-panel"
      open={open}
      aria-label="Mobile navigation"
    >
      <MobileNavScrollArea>
        <MobilePanelHeader>
          <Img src={PLL_SITE_LOGO} alt="PLL Logo" />
          <NavToggle open={open} setOpen={setOpen} />
        </MobilePanelHeader>

        {NAV_LINKS.map((item) => (
          <MobileNavItem key={item.linkText} onClick={handleClose}>
            <Lk link={item.link} alt={item.linkText}>{item.linkText}</Lk>
          </MobileNavItem>
        ))}
        <MobileNavItem onClick={handleClose}>
          <Lk link={createShopUTM({
            slug: '',
            medium: 'pll_stats',
            campaign: 'stats_navbar',
          })} alt="Shop">Shop</Lk>
        </MobileNavItem>

        <MobileSectionLabel>Teams</MobileSectionLabel>
        {TEAM_MENU.map((item) => (
          <MobileSubItem key={item.linkText} onClick={handleClose}>
            <Lk link={item.link} alt={item.linkText}>{item.linkText}</Lk>
          </MobileSubItem>
        ))}

        <MobileSectionLabel>More</MobileSectionLabel>
        {MORE_MENU.map((item) => (
          <MobileSubItem key={item.linkText} onClick={handleClose}>
            <Lk link={item.link} alt={item.linkText}>{item.linkText}</Lk>
          </MobileSubItem>
        ))}
      </MobileNavScrollArea>

      <MobileCtaContainer>
        <NavActionCon href={PLL_LINKS.tickets}>
          Tickets
        </NavActionCon>
      </MobileCtaContainer>
    </MobileNavPanel>
  )
}
